document.addEventListener('DOMContentLoaded', function() {
    // Get language from URL path
    const pathSegments = window.location.pathname.split('/').filter(segment => segment); // Split and remove empty segments
    let lang = 'de'; // Default to German
    
    // Check if first segment is a language code
    const firstSegment = pathSegments[0];
    if (firstSegment === 'en') lang = 'en';
    else if (firstSegment === 'pt') lang = 'ptbr';
    else if (firstSegment === 'es') lang = 'es';
    
    console.log('Detected language:', lang); // Debug: check detected language

    // Define translations
    const translations = {
        en: {
            sizeGuide: 'Size Guide',
            measurement: 'Measurements in centimeters',
            note: 'To protect the environment, we ask you to check the measurements beforehand - thank you very much :-)',
            chest: 'CHEST*',
            waist: 'WAIST*',
            hips: 'HIPS*'
        },
        de: {
            sizeGuide: 'Größenführer',
            measurement: 'Maße in Zentimeter',
            note: 'Um die Umwelt zu schonen, bitten wir Dich, vorab die Maße zu prüfen - vielen Dank :-)',
            chest: 'BRUST*',
            waist: 'TAILLIE*',
            hips: 'HÜFTE*'
        },
        ptbr: {
            sizeGuide: 'Guia de Tamanhos',
            measurement: 'Medidas em centímetros',
            note: 'Para proteger o meio ambiente, pedimos que você verifique as medidas antes - muito obrigado :-)',
            chest: 'PEITO*',
            waist: 'CINTURA*',
            hips: 'QUADRIL*'
        },
        es: {
            sizeGuide: 'Guía de Tallas',
            measurement: 'Medidas en centímetros',
            note: 'Para proteger el medio ambiente, te pedimos que verifiques las medidas de antemano - muchas gracias :-)',
            chest: 'PECHO*',
            waist: 'CINTURA*',
            hips: 'CADERAS*'
        }
    };

    // Use detected language (no need for fallback since all cases are covered)
    const currentLang = translations[lang] ? lang : 'de'; // Fallback to German just in case
    console.log('Final language used:', currentLang); // Debug: confirm final selection
    
    // Update Size Guide link text
    const sizeGuideLink = document.querySelector('.zify-sc-btn-open-modal');
    if (sizeGuideLink) {
        sizeGuideLink.textContent = translations[currentLang].sizeGuide;
    }

    // Update modal content - only the text parts
    const modalContent = document.querySelector('.zify-sc-light-modal-content');
    if (modalContent) {
        const paragraph = modalContent.querySelector('.zify-sc-light-modal-body p');
        if (paragraph) {
            paragraph.innerHTML = `<code>${translations[currentLang].measurement}</code><br><code>${translations[currentLang].note}</code>`;
        }

        const tableHeaders = modalContent.querySelectorAll('.table tr:first-child td');
        if (tableHeaders.length >= 7) {
            tableHeaders[4].textContent = translations[currentLang].chest;
            tableHeaders[5].textContent = translations[currentLang].waist;
            tableHeaders[6].textContent = translations[currentLang].hips;
        }
    }
});